// 电视剧演示数据（虚构内容，仅用于演示）
export const tvItems = [
  {
    id: "changan-tower",
    title: "长安十二楼",
    type: "tv",
    year: 2026,
    region: "中国大陆",
    director: "裴直",
    cast: ["顾怀之", "温书", "柳晚"],
    genres: ["古装", "悬疑"],
    updatedAt: "2026-10-13",
    views: 210000,
    rating: 9.0,
    poster: "https://readdy.ai/api/search-image?query=An%20elegant%20ancient%20Chinese%20cityscape%20at%20night%20lit%20by%20hanging%20lanterns%20and%20a%20lone%20figure%20on%20a%20tower%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-t01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=A%20panoramic%20ancient%20Chinese%20capital%20at%20dusk%20with%20layered%20rooftops%20and%20glowing%20lanterns%2C%20cinematic%20wide%20banner%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=zc-tb1&orientation=landscape",
    summary: "一夜之间，长安十二座高楼接连生变，小吏被卷入王朝暗局。",
    synopsis: "上元灯节前夕，长安城十二座高楼同时出现异象，负责登记户籍的小吏顾怀之被意外卷入其中。他凭借过人的记忆与推理，逐楼追查线索，却发现每一起异象都指向一桩被掩盖多年的旧案。随着案情逼近权力中枢，他必须在自保与真相之间做出选择。",
    subtitleNote: "已更新至第 12 集，简体中文 / 繁体中文 双语字幕，每周五更新一集。",
    featured: true,
    episodes: [
      { id: "changan-tower-1", index: 1, title: "第1集 · 灯节前夜", summary: "上元灯节前夕，长安第一高楼忽然传出异响，小吏顾怀之奉命前往登记。" },
      { id: "changan-tower-2", index: 2, title: "第2集 · 第二座楼", summary: "异象接连出现，顾怀之发现十二座楼的方位竟暗合星图。" },
      { id: "changan-tower-3", index: 3, title: "第3集 · 旧卷宗", summary: "一卷被刻意抹去的旧档案浮出水面，牵扯出十年前的失踪案。" },
      { id: "changan-tower-4", index: 4, title: "第4集 · 灯下人", summary: "顾怀之在灯市行踪被人跟踪，好友柳晚的身份也逐渐可疑。" },
      { id: "changan-tower-5", index: 5, title: "第5集 · 第三声钟", summary: "第三座楼敲响时，一桩尘封多年的秘密被当众揭开。" },
      { id: "changan-tower-6", index: 6, title: "第6集 · 破局之始", summary: "顾怀之拼出前六座楼的线索，却发现真正的棋盘才刚刚展开。" },
    ],
  },
  {
    id: "urban-glow",
    title: "都市浮光",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    director: "闻川",
    cast: ["江阔", "沈栖", "方哲"],
    genres: ["都市", "剧情"],
    updatedAt: "2026-10-11",
    views: 176000,
    rating: 8.6,
    poster: "https://readdy.ai/api/search-image?query=A%20modern%20city%20skyline%20at%20dusk%20seen%20through%20a%20high%20rise%20office%20window%20with%20rain%20streaks%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-t02&orientation=portrait",
    summary: "三个合租的年轻人在大城市浮沉，彼此照亮也彼此成全。",
    synopsis: "设计师沈栖、外卖骑手方哲与自由撰稿人江阔合租在一间老旧公寓里。他们各自背负着生活的压力与未完成的理想，在一次次争吵与扶持中慢慢找到方向。剧集以群像视角描摹都市青年的真实生活，温暖而克制。",
    subtitleNote: "已更新至第 16 集，简体中文 字幕，每周四更新两集。",
    episodes: [
      { id: "urban-glow-1", index: 1, title: "第1集 · 合租第一天", summary: "三个陌生人因为一条租房信息住进了同一间公寓。" },
      { id: "urban-glow-2", index: 2, title: "第2集 · 夜班", summary: "方哲的外卖订单出了意外，沈栖临时帮忙却闹出笑话。" },
      { id: "urban-glow-3", index: 3, title: "第3集 · 面试", summary: "江阔拿到一次重要面试机会，却在临门一脚时犹豫了。" },
      { id: "urban-glow-4", index: 4, title: "第4集 · 房租", summary: "房东突然要涨租，三个人第一次坐下来认真商量未来。" },
      { id: "urban-glow-5", index: 5, title: "第5集 · 加班夜", summary: "连续加班的沈栖在深夜崩溃，被室友的一碗热面安慰。" },
      { id: "urban-glow-6", index: 6, title: "第6集 · 微光", summary: "三个人各自的努力终于有了小小回报，也迎来新的选择。" },
    ],
  },
  {
    id: "wasteland-hunter",
    title: "荒原猎手",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    director: "贺东风",
    cast: ["郑铁山", "罗蔓"],
    genres: ["冒险", "动作"],
    updatedAt: "2026-09-26",
    views: 103000,
    rating: 8.0,
    poster: "https://readdy.ai/api/search-image?query=A%20lone%20warrior%20crossing%20a%20windy%20barren%20plain%20under%20a%20heavy%20grey%20sky%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-t03&orientation=portrait",
    summary: "资源枯竭的荒原上，赏金猎人为一份委托踏上未知旅途。",
    synopsis: "大灾变之后，荒原成为法外之地。赏金猎人老郑靠接委托维持生计，一次看似普通的护送任务却将他卷入两股势力的争斗。在缺水、风沙与背叛中，他重新审视自己坚持多年的规矩。剧集以硬朗的西部质感呈现末世生存图景。",
    subtitleNote: "已更新至第 10 集，简体中文 字幕，含生存设定注释。",
    episodes: [
      { id: "wasteland-hunter-1", index: 1, title: "第1集 · 委托", summary: "老郑在荒原驿站接到一单报酬异常丰厚的护送委托。" },
      { id: "wasteland-hunter-2", index: 2, title: "第2集 · 风沙", summary: "沙暴中队伍被迫分散，委托人的身份首次露出破绽。" },
      { id: "wasteland-hunter-3", index: 3, title: "第3集 · 水井", summary: "为寻找水源，一行人进入被遗弃的矿镇。" },
      { id: "wasteland-hunter-4", index: 4, title: "第4集 · 旧识", summary: "老郑在矿镇遇见了多年未见的旧搭档。" },
      { id: "wasteland-hunter-5", index: 5, title: "第5集 · 交锋", summary: "两股势力在荒原对峙，护送任务的真相浮出水面。" },
      { id: "wasteland-hunter-6", index: 6, title: "第6集 · 规矩", summary: "老郑必须在自己定下的规矩和委托人的性命之间选择。" },
    ],
  },
  {
    id: "code-abyss",
    title: "代码深渊",
    type: "tv",
    year: 2026,
    region: "中国大陆",
    director: "骆宁",
    cast: ["邱远", "苏挽", "周砚"],
    genres: ["科幻", "悬疑"],
    updatedAt: "2026-10-09",
    views: 168000,
    rating: 8.8,
    poster: "https://readdy.ai/api/search-image?query=A%20dark%20server%20room%20glowing%20with%20blue%20data%20streams%20and%20a%20silhouetted%20figure%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-t04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=An%20abstract%20digital%20tunnel%20of%20glowing%20data%20streams%20and%20circuit%20patterns%2C%20cinematic%20wide%20banner%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=zc-tb4&orientation=landscape",
    summary: "一段会自我迭代的代码，把程序员拖入真假难辨的深渊。",
    synopsis: "程序员邱远在维护一套老旧系统时，发现一段不受控制、能自我迭代的代码。随着这段代码开始影响真实世界的事件，他与搭档苏挽联手追踪其源头，却逐渐分不清自己是在排查故障，还是被某种存在选中。剧集以冷峻的科技感探讨意识与失控的边界。",
    subtitleNote: "已更新至第 8 集，简体中文 / 繁体中文 字幕，含技术术语注释。",
    featured: true,
    episodes: [
      { id: "code-abyss-1", index: 1, title: "第1集 · 异常日志", summary: "邱远在例行维护中发现一条不属于任何程序的日志。" },
      { id: "code-abyss-2", index: 2, title: "第2集 · 初现", summary: "异常代码第一次影响到现实世界的一次交通调度。" },
      { id: "code-abyss-3", index: 3, title: "第3集 · 搭档", summary: "安全工程师苏挽加入调查，两人对代码的来源产生分歧。" },
      { id: "code-abyss-4", index: 4, title: "第4集 · 镜像", summary: "邱远发现代码似乎在模仿他自己的思维方式。" },
      { id: "code-abyss-5", index: 5, title: "第5集 · 断网", summary: "为阻止扩散，团队决定物理隔离服务器，却付出代价。" },
      { id: "code-abyss-6", index: 6, title: "第6集 · 深渊回望", summary: "当代码开始对话，邱远必须回答一个没有标准答案的问题。" },
    ],
  },
  {
    id: "family-feast",
    title: "家宴风云",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    director: "闻川",
    cast: ["温若", "田川", "安琪"],
    genres: ["家庭", "剧情"],
    updatedAt: "2026-09-19",
    views: 72000,
    rating: 7.8,
    poster: "https://readdy.ai/api/search-image?query=A%20warm%20family%20dining%20table%20lit%20by%20soft%20lamplight%20with%20steaming%20dishes%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-t05&orientation=portrait",
    summary: "一张团圆饭桌，藏着三代人说不出口的心事。",
    synopsis: "老厨师温伯每年春节都要亲手操办一桌家宴，今年却因一次意外住进了医院。三个性格迥异的子女被迫接手，从选菜、备料到上桌，重新面对彼此积压多年的矛盾。剧集用一桌家常菜串起三代人的亲情与和解。",
    subtitleNote: "已更新至第 14 集，简体中文 字幕。",
    episodes: [
      { id: "family-feast-1", index: 1, title: "第1集 · 年夜饭", summary: "温伯在备菜时突然入院，家宴被临时交到子女手中。" },
      { id: "family-feast-2", index: 2, title: "第2集 · 菜单", summary: "三兄妹为菜单争执不休，谁都不肯让步。" },
      { id: "family-feast-3", index: 3, title: "第3集 · 老菜谱", summary: "一本泛黄的菜谱里，藏着父母年轻时的故事。" },
      { id: "family-feast-4", index: 4, title: "第4集 · 灶台前", summary: "大哥第一次下厨，把厨房搞得一团糟。" },
      { id: "family-feast-5", index: 5, title: "第5集 · 客人", summary: "一位意外来客让家宴的气氛变得微妙。" },
      { id: "family-feast-6", index: 6, title: "第6集 · 开席", summary: "家宴终于开席，那些没说出口的话也终于有了出口。" },
    ],
  },
  {
    id: "ace-intern",
    title: "王牌实习",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    director: "蔡悦",
    cast: ["丁小满", "江阔", "纪然"],
    genres: ["都市", "喜剧"],
    updatedAt: "2026-09-12",
    views: 58000,
    rating: 7.5,
    poster: "https://readdy.ai/api/search-image?query=A%20busy%20modern%20office%20with%20a%20confident%20young%20intern%20carrying%20a%20stack%20of%20documents%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-t06&orientation=portrait",
    summary: "一个初入职场的新人，用最笨的方法闯出一片天。",
    synopsis: "应届生丁小满进入一家大公司实习，面对看不懂的报表、记不住的人名和永远做不完的杂活，他没有捷径，只有一股不服输的劲。在一连串笑料百出的失误后，他慢慢找到了自己的位置。剧集以轻喜剧笔触描绘职场新人的成长。",
    subtitleNote: "已更新至第 20 集，简体中文 字幕。",
    episodes: [
      { id: "ace-intern-1", index: 1, title: "第1集 · 入职", summary: "丁小满第一天上班就认错了老板，还打翻了咖啡。" },
      { id: "ace-intern-2", index: 2, title: "第2集 · 早会", summary: "被安排做会议记录的他，把整场早会记成了流水账。" },
      { id: "ace-intern-3", index: 3, title: "第3集 · 加班", summary: "为了赶一份方案，他第一次体会到大厂的深夜。" },
      { id: "ace-intern-4", index: 4, title: "第4集 · 导师", summary: "一位严厉的前辈成了他的临时导师。" },
      { id: "ace-intern-5", index: 5, title: "第5集 · 转正", summary: "转正答辩临近，他却把最重要的数据弄丢了。" },
      { id: "ace-intern-6", index: 6, title: "第6集 · 第一步", summary: "答辩当天，他用最真诚的方式赢回了信任。" },
    ],
  },
  {
    id: "rivers-and-mountains",
    title: "山河故人录",
    type: "tv",
    year: 2021,
    region: "中国大陆",
    director: "裴直",
    cast: ["顾怀之", "柳晚"],
    genres: ["历史", "剧情"],
    updatedAt: "2026-09-03",
    views: 47000,
    rating: 8.3,
    poster: "https://readdy.ai/api/search-image?query=An%20epic%20historic%20landscape%20with%20ancient%20architecture%20in%20rolling%20mist%20and%20a%20distant%20rider%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-t07&orientation=portrait",
    summary: "乱世之中，一位史官用一支笔记录山河与人心的变迁。",
    synopsis: "王朝更替的年代，年轻史官奉命修撰前朝旧史。他不愿曲笔，也不忍直书，在朝堂压力与故人情谊之间反复权衡。随着一批批往事被记录、被涂改、被遗忘，他逐渐明白史书真正的重量。剧集以沉稳的叙事还原一段动荡岁月。",
    subtitleNote: "已更新至第 24 集，简体中文 字幕，含史实背景注释。",
    episodes: [
      { id: "rivers-and-mountains-1", index: 1, title: "第1集 · 修史", summary: "年轻史官受命修撰前朝旧史，第一日便遇难题。" },
      { id: "rivers-and-mountains-2", index: 2, title: "第2集 · 曲笔", summary: "一位权贵暗示他删改某段记载，他陷入两难。" },
      { id: "rivers-and-mountains-3", index: 3, title: "第3集 · 故人", summary: "旧日同窗的出现，让他想起学堂里的约定。" },
      { id: "rivers-and-mountains-4", index: 4, title: "第4集 · 一页纸", summary: "一页被撕去的旧稿，牵出一段被掩埋的往事。" },
      { id: "rivers-and-mountains-5", index: 5, title: "第5集 · 落笔", summary: "在动乱前夜，他终于写下自己的第一个字。" },
      { id: "rivers-and-mountains-6", index: 6, title: "第6集 · 山河", summary: "山河依旧，人已不同，史书却留了下来。" },
    ],
  },
  {
    id: "night-code",
    title: "暗夜编码",
    type: "tv",
    year: 2020,
    region: "中国香港",
    director: "麦子谦",
    cast: ["高维", "何兆铭"],
    genres: ["犯罪", "惊悚"],
    updatedAt: "2026-08-25",
    views: 41000,
    rating: 7.9,
    poster: "https://readdy.ai/api/search-image?query=A%20hacker%20silhouette%20in%20a%20dim%20room%20lit%20only%20by%20screen%20glow%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-t08&orientation=portrait",
    summary: "一名白帽黑客被卷入连环网络罪案，真凶就在身边。",
    synopsis: "白帽黑客阿维受雇于一家安全公司，负责追查一起针对城市交通系统的攻击。随着调查推进，他发现攻击者的手法与自己早年的一段经历如出一辙。当信任的伙伴一个个被怀疑，他不得不怀疑，真正的幕后之人也许正是最亲近的人。",
    subtitleNote: "已更新至第 12 集，简体中文 字幕，含网络安全术语注释。",
    episodes: [
      { id: "night-code-1", index: 1, title: "第1集 · 入侵", summary: "城市交通系统遭攻击，阿维被紧急叫回公司。" },
      { id: "night-code-2", index: 2, title: "第2集 · 痕迹", summary: "攻击留下的痕迹，让阿维想起自己的一段过去。" },
      { id: "night-code-3", index: 3, title: "第3集 · 内鬼", summary: "公司内部开始互相猜疑，第一条线索指向同事。" },
      { id: "night-code-4", index: 4, title: "第4集 · 追踪", summary: "阿维独自追踪一个旧IP，险些落入陷阱。" },
      { id: "night-code-5", index: 5, title: "第5集 · 旧账", summary: "一段被删除的聊天记录，揭开多年前的恩怨。" },
      { id: "night-code-6", index: 6, title: "第6集 · 现身", summary: "幕后之人终于现身，身份却在所有人意料之外。" },
    ],
  },
  {
    id: "youth-chronicle",
    title: "青春纪事簿",
    type: "tv",
    year: 2019,
    region: "中国大陆",
    director: "沈温",
    cast: ["纪然", "林一诺"],
    genres: ["爱情", "剧情"],
    updatedAt: "2026-08-15",
    views: 36000,
    rating: 7.6,
    poster: "https://readdy.ai/api/search-image?query=Students%20on%20a%20sunlit%20campus%20lawn%20with%20soft%20bokeh%20and%20long%20afternoon%20shadows%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-t09&orientation=portrait",
    summary: "一本共享的日记本，记录了一群少年的三年时光。",
    synopsis: "高中开学第一天，一本在班级里传阅的日记本成了少年们共同的秘密。他们在上面写下心愿、抱怨与不敢当面说的话。三年后毕业那天，日记本重新回到最初的作者手里，也带回了一段没有说完的青春。",
    subtitleNote: "已更新至第 18 集，简体中文 字幕。",
    episodes: [
      { id: "youth-chronicle-1", index: 1, title: "第1集 · 开学", summary: "一本日记本在班级里悄悄传开，成了大家的秘密。" },
      { id: "youth-chronicle-2", index: 2, title: "第2集 · 同桌", summary: "转学生纪然坐到最后一排，成了日记本的新主人。" },
      { id: "youth-chronicle-3", index: 3, title: "第3集 · 运动会", summary: "一场接力赛让原本疏远的同学们第一次并肩。" },
      { id: "youth-chronicle-4", index: 4, title: "第4集 · 月考", summary: "成绩公布后，日记本里多了几行潦草的字。" },
      { id: "youth-chronicle-5", index: 5, title: "第5集 · 晚自习", summary: "停电的晚自习，成了少年们最难忘的一夜。" },
      { id: "youth-chronicle-6", index: 6, title: "第6集 · 毕业", summary: "日记本回到最初作者手中，青春也有了答案。" },
    ],
  },
  {
    id: "star-ferryman",
    title: "星际摆渡人",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    director: "顾南舟",
    cast: ["方骁", "叶紫", "周砚"],
    genres: ["科幻", "冒险"],
    updatedAt: "2026-10-07",
    views: 149000,
    rating: 8.7,
    poster: "https://readdy.ai/api/search-image?query=A%20small%20spaceship%20drifting%20past%20a%20giant%20ringed%20planet%20in%20deep%20space%2C%20cinematic%20poster%20art%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=zc-t10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=A%20vast%20ringed%20planet%20with%20a%20small%20cargo%20ship%20crossing%20its%20shadow%20and%20glowing%20stars%2C%20cinematic%20wide%20banner%20with%20a%20moody%20atmospheric%20background%2C%20cohesive%20muted%20color%20grading%2C%20dramatic%20soft%20lighting%2C%20rich%20film%20texture%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=zc-tb10&orientation=landscape",
    summary: "一艘客运飞船的船长，载着陌生人穿越星海，也载着自己的往事。",
    synopsis: "老船长方骁驾驶着一艘老旧客运飞船，往返于几颗殖民星球之间。每一趟航程，他都会遇到形形色色的乘客，也一次次被他们的故事触动。当他决定完成一趟无人敢接的禁忌航线时，过去的秘密也不得不面对。剧集以单元剧形式讲述星际旅途中的相遇与告别。",
    subtitleNote: "已更新至第 10 集，简体中文 / 繁体中文 字幕，含设定注释。",
    featured: true,
    episodes: [
      { id: "star-ferryman-1", index: 1, title: "第1集 · 起航", summary: "老旧客运飞船启程，第一位乘客带着奇怪的行李登船。" },
      { id: "star-ferryman-2", index: 2, title: "第2集 · 中转站", summary: "在中转站补给时，一名乘客突然失踪。" },
      { id: "star-ferryman-3", index: 3, title: "第3集 · 引力井", summary: "飞船被迫进入行星引力井，全员陷入危险。" },
      { id: "star-ferryman-4", index: 4, title: "第4集 · 旧航线", summary: "方骁决定改道，走一条多年无人使用的航线。" },
      { id: "star-ferryman-5", index: 5, title: "第5集 · 摆渡", summary: "面对星际难民的求助，船员们意见不一。" },
      { id: "star-ferryman-6", index: 6, title: "第6集 · 归宿", summary: "航程终点在望，方骁也终于面对自己的过去。" },
    ],
  },
];